module.exports = __webpack_public_path__ + "static/media/Illus-Bread_2@3x.a442bcbe.png";